import type { SuitabilityTestDefinition } from 'src/suitability/engine/types';
import type { LiftAnswers } from '../v1/answers';
import { liftV1 } from '../v1/definition';

/**
 * Test de idoneidad MiFID II de Lift, versión 2.
 *
 * Sólo cambian los pesos de algunas opciones, y los pesos viven en el motor del API: las
 * preguntas, las respuestas y los pasos son los de v1, así que la definición también.
 * Si una versión futura cambia preguntas, tendrá sus propios pasos en su carpeta.
 */
export const liftV2: SuitabilityTestDefinition<LiftAnswers> = {
  ...liftV1,
  version: 'v2',
};
